module.exports = __webpack_public_path__ + "static/media/ICONS_TIPOS DE CONCEPTOS.a7a4e9e2.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/ICONS/ICONS_TIPOS DE CONCEPTOS.svg
// module id = 489
// module chunks = 0